import { render, staticRenderFns } from "./weekTest.vue?vue&type=template&id=03811d52&scoped=true&"
import script from "./weekTest.vue?vue&type=script&lang=js&"
export * from "./weekTest.vue?vue&type=script&lang=js&"
import style0 from "./weekTest.vue?vue&type=style&index=0&id=03811d52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03811d52",
  null
  
)

export default component.exports